import { HiOutlinePlus } from "react-icons/hi2";
import Tile from "../tile";

export default function TileList({ tiles, onDelete, onClickCreate, onExport, onImport, onImportRequest }) { // Destructuring tiles from props
  return (
    <div className="grid grid-cols-1 gap-4 pb-8 pt-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {tiles.map((tile, index) => (
        <Tile key={index} app={tile.record} onDelete={onDelete} onExport={onExport} onImport={onImport} onImportRequest={onImportRequest} /> // Passed the entire tile object to the Tile component
      ))}
      <button
        type="button"
        onClick={onClickCreate}
        aria-label="Create new application"
        className="group flex min-h-[104px] cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed
          border-gray-200 text-gray-400 transition-all duration-200 hover:border-gray-300 hover:bg-gray-50/60 hover:text-gray-600"
      >
        <HiOutlinePlus className="h-7 w-7 transition-transform duration-200 group-hover:scale-110" />
        <span className="text-sm font-medium">New Application</span>
      </button>
    </div>
  );
}
